import { CheckoutOrderValidationError, CheckoutOrderValidationRule } from "../enum/checkout-order-validation.enum";

export const checkoutOrderProductsAvailabilityRule: CheckoutOrderValidationRule = ({
	unavailableProducts,
}) =>
	unavailableProducts.length > 0
		? CheckoutOrderValidationError.ProductsUnavailable
		: null;
